import LoginService from '@/services/LoginService'
import UsuarioService from '@/services/UsuarioService'
import MetodosGlobais from '@/utils/MetodosGlobais'


const user = JSON.parse(sessionStorage.getItem('user')) || JSON.parse(localStorage.getItem('user'))
const initialState = user
  ? (sessionStorage.setItem('user', JSON.stringify(user)), { status: { loggedIn: true }, user })
  : { status: {}, user: {} }

export const authentication = {
  namespaced: true,
  state: initialState,
  actions: {
    login ({ dispatch, commit }, { username, password, manter }) {
      commit('loginRequest', { username, manter })
      return LoginService.login({ username, password })
        .then(
          token => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            var user = MetodosGlobais.decodificarToken(token.data.token)
            user.token = token.data.token
            user.refreshToken = token.data.refresh_token
            commit('loginGettingPrivileges', user)
            UsuarioService.getUsuarioPrivilegios(user.idUsuario)
              .then(
                response => {
                  user.privilegios = []
                  if (typeof response.data.codigo === 'undefined') {
                    response.data.forEach(
                      item => { user.privilegios.push(item.nome) }
                    )
                  }
                  commit('loginSuccess', user)
                  return response
                },
                error => {
                  commit('loginFailure', error)
                  return error
                  // dispatch('alert/error', error, { root: true });
                }
              )
          },
          error => {
            commit('loginFailure', error)
            return error
            // dispatch('alert/error', error, { root: true });
          }
        )
    },
    logout ({ commit }) {
      commit('logout')
    },
    refresh ({ state, commit }) {
      /* Faz request ao servidor de refresh */
      return LoginService.refresh(state.user.refreshToken)
      // Se for uma resposta válida
        .then(response => {
          /* Decodifica e salva o token no objeto user */
          var user = MetodosGlobais.decodificarToken(response.data.token)
          user.token = response.data.token
          user.refreshToken = response.data.refresh_token
          /* Busca os privilégios do usuário buscado */
          commit('loginGettingPrivileges', user)
          return UsuarioService.getUsuarioPrivilegios(user.idUsuario)
            .then(
              response => {
                user.privilegios = []
                /* Se não houver mensagem de erro do Backend, adiciona os privilégios */
                if (typeof response.data.codigo === 'undefined') {
                  response.data.forEach(
                    item => { user.privilegios.push(item.nome) }
                  )
                }
                /* Atualiza as novas informações na store e retorna a response */
                commit('refreshToken', user)
                return response
              },
              error => {
                return error
              }
            )
        },
        error => {
          return error
        })

      // return "401";
    },
    async prefeito ({ commit }) {
      try {
        let user = await UsuarioService.getUsuarioVideoWall()

        if (user.status == 200) {
          user.data.perfis = []
          user.data.listaPerfil.forEach(item => {
            user.data.perfis.push(item.nome)
          })
          try {
            let response = await UsuarioService.getUsuarioPrivilegios(user.data.id)

            if (response.status == 200) {
              user.data.privilegios = []
              response.data.forEach(
                item => { user.data.privilegios.push(item.nome) }
              )
            }

            commit('loginByIP', user.data)
            return user
          } catch (err) {
            commit('loginFailure', err)
            throw err
          }
        }
      } catch (err) {
        MetodosGlobais.logarErro(err.data.Mensagem, 'error')
        throw err
      }
    },
  },
  mutations: {
    loginRequest (state, { user, manter }) {
      state.status = { loggingIn: true }
      state.user = user
      state.keepLogged = manter
    },
    loginGettingPrivileges (state, user) {
      state.user = user
    },
    loginSuccess (state, user) {
      sessionStorage.setItem('user', JSON.stringify(user))
      if (state.keepLogged) { localStorage.setItem('user', JSON.stringify(user)) }
      state.status = { loggedIn: true }
      state.user = user
    },
    loginFailure (state) {
      state.status = {}
      state.user = {}
    },
    logout (state) {
      localStorage.removeItem('user')
      sessionStorage.removeItem('user')
      sessionStorage.removeItem('localizacao')
      sessionStorage.removeItem('rotasCanonicas')
      state.status = {}
      state.user = {}
    },
    refreshToken (state, user) {
      state.user = user
      sessionStorage.setItem('user', JSON.stringify(user))
      if (state.keepLogged) { localStorage.setItem('user', JSON.stringify(user)) }
    },
    loginByIP (state, user) {
      state.status = { loggedByIP: true }
      state.user = user
    },
  },
}
